import { useEffect } from "react";

import { API } from "@/lib/api";

export default function KanbanRedirect() {
  useEffect(() => {
    window.location.assign(`${API}/kanban/`);
  }, []);

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(214,179,92,0.22),_transparent_34%),linear-gradient(135deg,_#090806,_#17120a_58%,_#2b2418)] flex items-center justify-center">
      <div className="rounded-2xl border border-white/10 bg-white/10 px-8 py-7 text-center shadow-2xl backdrop-blur-xl">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#d6b35c] mx-auto mb-4"></div>
        <p className="text-stone-100">Öffne geschütztes Kanban...</p>
      </div>
    </div>
  );
}
